import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Row } from 'reactstrap';
import { useTranslation } from '../../../translations';
import { Fetcher, useBoolState, useFetcher } from '../../../utils';
import { CreateModal } from './CreateModal';
import { SurchargesListItem } from './surchargesListItem';

export const SurchargesList: FC = () => {
  const { ts } = useTranslation();
  const history = useHistory();
  const [openModal, enableModal, disableModal] = useBoolState(false);

  const fetcher = useFetcher(async () => await api.getSurcharges());

  if (!fetcher.data) {
    return <Fetcher result={fetcher} />;
  }

  return (
    <>
      <div>
        <Button color="primary" id="createSurcharge" onClick={enableModal}>
          {ts('create_new_surcharge')}
        </Button>
      </div>
      <hr />
      <Row className="justify-content-center">
        {fetcher.data.map((surcharge) => (
          <SurchargesListItem key={surcharge.id} surcharge={surcharge} />
        ))}
      </Row>
      <CreateModal
        onCancel={disableModal}
        onUpdate={(id) => {
          toast.success(ts('created_new_surcharge'));
          history.push(`/housekeeping/surcharges/${id}`);
        }}
        open={openModal}
      />
    </>
  );
};
